export const AppEnvMap = {
  Env: import.meta.env.VITE_ENV,
  BaseUrl:
    import.meta.env.VITE_DOCKER_BASE_URL || import.meta.env.VITE_BASE_URL,
  WebAppHost: import.meta.env.VITE_WEB_APP_HOST,
  CfSiteKey: import.meta.env.VITE_CF_TURNSTILE_SITEKEY,
  SdkApiUrl: import.meta.env.VITE_SDK_API_URL,
};

export const AppEnvironment = {
  Test: 'test',
  Prod: 'production',
  Dev: 'development',
} as const;
